import { render, staticRenderFns } from "./EmailAction.vue?vue&type=template&id=44d7bf24&"
import script from "./EmailAction.vue?vue&type=script&lang=js&"
export * from "./EmailAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports